(function () {
  'use strict';

  // Build Your Set pairs each product and charge by _set_id + _set_index.
  // Older bundles instead share _bundle_group. Never treat a set charge as
  // an older bundle charge: only the charge carries _bundle_group in a set.
  //
  // Legacy monogram lines added from the standard PDP have no _bundle_group
  // property and are never touched by this script.

  var busy = false;
  var timer = null;
  var pending = false;

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function isPersonalisationLine(item) {
    var type = (item.product_type || '').toLowerCase();
    return type === 'personalisation';
  }

  function groupOf(item) {
    return (item.properties && item.properties._bundle_group) || null;
  }

  function setLineOf(item) {
    var p = item.properties || {};
    return p._set_id && p._set_index
      ? JSON.stringify([String(p._set_id), String(p._set_index)]) : null;
  }

  function finish() {
    busy = false;
    if (pending) { pending = false; scheduleCleanup(300); }
  }

  function refreshCartUi() {
    try {
      if (window.cart && typeof window.cart.getCart === 'function') {
        window.cart.getCart(false);
        return;
      }
    } catch (e) { /* fall through */ }
    if (window.location.pathname.indexOf('/cart') === 0) {
      window.location.reload();
    }
  }

  function cleanup() {
    if (busy) { pending = true; return; }
    busy = true;

    fetch(root() + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = (cart && cart.items) || [];
        var aliveGroups = Object.create(null);
        var setQuantities = Object.create(null);
        var monogramQuantities = Object.create(null);
        var updates = {};

        items.forEach(function (item) {
          var monogramId = item.properties && item.properties._monogram_id;
          if (monogramId && !isPersonalisationLine(item)) {
            var feeUnits = 1;
            if (item.properties._bundle_group && item.properties._bundle_monogram_variants) {
              try { var variants = JSON.parse(item.properties._bundle_monogram_variants); if (Array.isArray(variants) && variants.length) feeUnits = variants.length; } catch (e) { return; }
            }
            monogramQuantities[monogramId] = (monogramQuantities[monogramId] || 0) + item.quantity * feeUnits;
          }
          var g = groupOf(item);
          if (g && !isPersonalisationLine(item)) aliveGroups[g] = true;
          var pair = setLineOf(item);
          if (pair && !isPersonalisationLine(item) &&
              item.properties.Personalisation === 'Monogram') {
            setQuantities[pair] = (setQuantities[pair] || 0) + item.quantity;
          }
        });

        items.forEach(function (item) {
          if (!isPersonalisationLine(item)) return;
          var pair = setLineOf(item);
          var monogramId = item.properties && item.properties._monogram_id;
          if (monogramId) {
            var quantity = monogramQuantities[monogramId] || 0;
            if (item.properties && item.properties._bundle_monogram_charge === 'true') {
              if (!quantity) updates[item.key] = 0;
            } else if (item.quantity !== quantity) updates[item.key] = quantity;
          } else if (pair) {
            var quantity = setQuantities[pair] || 0;
            if (item.quantity !== quantity) updates[item.key] = quantity;
          } else {
            var g = groupOf(item);
            if (g && !aliveGroups[g]) updates[item.key] = 0;
          }
        });

        if (!Object.keys(updates).length) {
          finish();
          return;
        }

        return fetch(root() + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates })
        })
          .then(function (r) {
            if (!r.ok) throw new Error('Personalisation charge update failed');
            return r.json();
          })
          .then(function () {
            finish();
            refreshCartUi();
          });
      })
      .catch(function () { finish(); });
  }

  function scheduleCleanup(delay) {
    clearTimeout(timer);
    timer = setTimeout(cleanup, delay || 400);
  }

  if (window.fetch) {
    var nativeFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = '';
      try {
        url = (typeof input === 'string' ? input : (input && input.url)) || '';
      } catch (e) { url = ''; }

      var result = nativeFetch.apply(this, arguments);
      if (/\/cart\/(change|update|clear)/.test(url)) {
        result.then(function () { scheduleCleanup(300); }).catch(function () {});
      }
      return result;
    };
  }

  if (window.XMLHttpRequest) {
    var open = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      try {
        if (typeof url === 'string' && /\/cart\/(change|update|clear)/.test(url)) {
          this.addEventListener('load', function () { scheduleCleanup(300); });
        }
      } catch (e) { /* ignore */ }
      return open.apply(this, arguments);
    };
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('[data-item-remove], [data-quantity-button], .cart__item__remove')) {
      scheduleCleanup(900);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scheduleCleanup(600); });
  } else {
    scheduleCleanup(600);
  }
})();


